<template>
    <div class="stream_formation_box">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <template v-if="isPro">
			<div class="inMain_box">
				<div class="informdata_tit">Manual Stocktakes COGs</div>
				<div class="new_topBtn">
					<div class="newEnter_btn" @click="showAdd">Enter this week’s COGs</div>
					<div class="extra_btn" :class="{'disable_new':showDis}" @click="showDel">Re-Stocktakes</div>
				</div>
				<div>
					<el-table
					:data="tableData"
					border
					class="venue_table"
					style="width: 100%">
						<el-table-column
						prop="label"
						align="center"
						label-class-name="roster_th"
						class-name="roster_row"
						label="Week">
							<template slot-scope="scope">
								{{scope.row.weekMonDay}} - {{scope.row.weekSunDay}}
							</template>
						</el-table-column>
						<el-table-column
						prop="name"
						align="center"
						label-class-name="roster_th"
						class-name="roster_row"
						label="Cost">
							<template slot-scope="scope">
								{{scope.row.cost?`$${scope.row.cost}`:'-'}}
							</template>
						</el-table-column>
						<el-table-column
						prop="address"
						align="center"
						label-class-name="roster_th"
						class-name="roster_row"
						label="Operating">
							<template slot-scope="scope">
								<span style="font-size:18px;cursor:pointer;color:#EA3796;margin-right:20px;" @click="editExtra(scope.row,scope.$index)">{{scope.row.cost?'Edit':'Enter'}}</span>
								<span style="font-size:18px;cursor:pointer;color:#FF4E4E" @click="showDel(scope.row,scope.$index,'one')">Delete</span>

							</template>
						</el-table-column>
						<template slot="empty">
							<i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
							<div v-else>No Data</div>
						</template>
					</el-table>
				</div>
			</div>
		</template>

		<template v-if="isDoneLoad && !isPro">
			<div class="error-container d-flex align-items-center justify-content-center">
                <card-unauthorized></card-unauthorized>
            </div>
		</template>

		<el-dialog
        :title="dioTit"
        :visible.sync="extraDio"
        :modal-append-to-body="false"
        :show-close='false'
        class="editCardDio"
        :close-on-click-modal='false'
        width="840px"
        center>
            <div class="m-bottom-2rem">
                <div class="tag_tit_new">Cost</div>
                <el-input v-model="cost" maxlength="10" class="borderNone">
					<span slot="prefix" class="increaseIcon_new">$</span>
				</el-input>
            </div>

			<div>
                <div class="tag_tit_new">Week</div>
				<el-select v-model="week" class="peiso-select-default w-100" placeholder="No Data" @change="lisKey">
					<el-option
					v-for="item in weekOptions"
					:key="item.value"
					:label="item.value"
					:value="item"
					:class="{'selected' : item.dashBoardId == selectedWeek.dashBoardId}">
					</el-option>
				</el-select>
			</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelOperate" class="cardCanBtn">Cancel</el-button>
                <el-button @click="confirmMsg" class="cardConBtn">Confirm<i v-if="requesting" class="el-icon-loading" style="margin-left:4px"></i></el-button>
            </span>
        </el-dialog>

        <el-dialog
        title=""
        :visible.sync="reDiolog"
        :modal-append-to-body="false"
        :show-close='false'
        class="delEmployDio"
        :close-on-click-modal='false'
        width="840px"
        center>
            <div class="rediolog_content">
                After Re-Stocktakes, the current data will be cleared and a <br/>
                new record will be started. Are you sure to continue?
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reDiolog = false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="delCogs" class="cardConBtn">Confirm</el-button>
            </span>
        </el-dialog>

		<el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>
    </div>
</template>

<script>
import api from '../../api/api'
import cardUnauthorized from '@/components/card/unauthorized';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
export default {
    data() {
        return {
			dioTit:'Edit COGs Cost',
			// tableData:[{label:'11/07/2021-17/07/2021',cost:100}],
			tableData:[],
			extraDio:false,
			reDiolog:false,
			cost:'',
			loading:false,
			showDis:true,
			editMsg:'',
			msg:'',
			index:0,
			delMsg:'',
			requesting: false,
            isPro: false,
            isDoneLoad: false,
			venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
			weekOptions: [],
			selectedWeek: {},
			week: null,
        }
    },
    methods: {
        cancel(){
            this.$router.push({path:'/setting'})
		},
		showDel(val,index,type){
			if(this.showDis) return
			if(type=='one'){
				this.delMsg = val
			}
			this.reDiolog=true
		},
		delCogs(){
			if(this.showDis) return
			if(this.delMsg){
				api.delManualCogs({id:this.delMsg.id},res=>{
					let {code,data,message}=res.data;
					this.loading = false
					this.reDiolog = false
					this.showDis =true
					if(code==0){
						this.getList()
					}else if (res.data.code == 8902) {
							sessionStorage.clear()
							this.$router.push('/login')
					}else{
						Utils.alert('',message,'error')
					}
				})
				return
			}
			api.delManualCogsList('',res=>{
				let {code,data,message}=res.data;
                this.loading = false
                this.reDiolog = false
				this.showDis =true
                if(code==0){
					this.getList()
                }else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        this.$router.push('/login')
                }else{
                    Utils.alert('',message,'error')
                }
			})
		},
		getList() {
            this.loading = true
			const pat = {
				pageNum:1,
				pageSize:10
			}
            api.manualCogsList({
				pat:pat,
                callback: (res) => {
                    this.loading = false
                    if(res.data.code == 0){
						const data = res.data.data.list
						this.tableData = data
						this.tableData.forEach((item,i)=>{
							this.showDis = false
							item.cost = Utils.formatSplit(item.cost)
						})
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        this.$router.push('/login')
                    } else{
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        },
		showAdd(){
			
			if(this.tableData[0]&&!Utils.getNowDateNew(this.tableData[0].weekSunDay)){
				this.editExtra(this.tableData[0],0)
				return
			}
			this.extraDio = true
			this.dioTit = 'Enter COGs Cost'
			// this.dioTit=this.tableData[0]?this.tableData[0].cost.toString()==''?'Enter COGs Cost':'Edit COGs Cost':'Enter COGs Cost'
		},
		editExtra(msg,index){ // 修改
			this.index = index
			this.extraDio=true
			this.msg = msg
            this.cost = msg?msg.cost.split(',').join(""):''
			this.dioTit=msg.cost.toString()==''?'Enter COGs Cost':'Edit COGs Cost'
		},
		cancelOperate() {
			if (this.requesting)
				return
			this.extraDio = false
			this.name=''
			this.commis=''
			this.isName=false
		},
		confirmMsg(){
			if(this.cost.toString()==''){
				Utils.alert2('','Please enter cost','error')
				return
			}
			if (this.requesting)
				return
			this.requesting = true
			const pat = {
				cost: this.cost,
				id: this.msg.id?this.msg.id:'',
				// weekMonDay:this.msg?this.msg.weekMonDay:Utils.getThis7Days()[0],
				// weekSunDay:this.msg?this.msg.weekSunDay:Utils.getThis7Days()[1]
				weekMonDay: this.selectedWeek.firstDateFormat,
				weekSunDay: this.selectedWeek.lastDateFormat
			}
			api.editManualCogs(pat,this.callback)
		},
		callback(res,status){
			this.loading=false;
			this.requesting = false
			let {code , message ,data} = res.data
            if(code==0){
                switch (status) {
                    case 'editManualCogs':
                        this.extraDio = false
						this.cost=''
						this.msg = ''
						this.index = ''
						this.editMsg=''
						this.getList()
                    break;
                }
            }else{
                this.extraDio = false
                this.cost=''
                Utils.alert('',message,'error')
            }
		},

		closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		},

		getWeekSelection() {
			var weekList = Utils.getWeekSelection(1)
			this.selectedWeek = weekList[0]
			this.weekOptions = weekList
			this.week = weekList[0].value
			console.log(weekList)
		},

		
		lisKey(e) {
			this.week = e.value
			this.selectedWeek = e
			console.log(e)
		},
	},
    components: {
        cardUnauthorized: cardUnauthorized,
		freeTrialNotice: freeTrialNotice
    },
	mounted() {
		this.getList()
		this.$root.$on('isPro', (isPro, others) => { 
			this.isPro = isPro
			this.isDoneLoad = true

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
		})

		this.getWeekSelection() 
	},
	watch: {
		extraDio(n,o){
			if(!n){
                this.cost ='' 
			}
		},
		cost(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.cost = o;
					}, 100);
				}
			}
		}
	},
}
</script>

<style lang="scss">
    .stream_formation_box{
        position: relative;
        .inform_tit{
            height:76px;
            font-size:14px;
            font-weight:600;
            color:var(--text-color);
            line-height:20px;
            width: 100%;
            background-color: var(--background-color);
            z-index: 100;
            .cancel_box{
                cursor: pointer;
                width: 150px;
            }
        }
        .inMain_box{
            background-color: var(--background-color-4);
            width: 100%;
            box-sizing: border-box;
			padding:50px 30px;
			margin-bottom: 40px;
			.informdata_tit{
                text-align: center;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:var(--text-color);
                line-height:42px;
			}
			.extra_btn{
				width:400px;
				height:60px;
				font-size:26px;
				font-weight:600;
				color:rgba(234,55,150,1);
				line-height:60px;
				text-align: center;
				border: 1px solid rgba(234,55,150,1);
				cursor: pointer;
				margin: 0 auto;
			}
		}
		.tag_tit_new{
			height:16px;
			font-size:14px;
			font-weight:400;
			color:var(--text-color);
			line-height:16px;
			margin: 10px 0 20px 0;
		}
		.errmsg{
			height:25px;
			font-size:18px;
			font-weight:400;
			color:var(--text-color);
			line-height:25px;
			margin-top: 15px;
		}
        .increaseIcon_new{
            font-size: 22px;
            line-height: 52px;
            margin-left: 5px;
        }
        .rediolog_content{
            text-align: center;
            font-size: 24px;
            font-weight: 600;
            color: var(--text-color);
            line-height: 33px;
        }
		.new_topBtn{
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 55px;
			.newEnter_btn{
				width: 384px;
				height: 60px;
				background: var(--background-color-4);
				border: 2px solid var(--text-color);
				font-size: 26px;
				font-weight: 600;
				color: var(--text-color);
				line-height: 60px;
				text-align: center;
				cursor: pointer;
				margin-right: 50px;
			}
			.extra_btn{
				width:384px !important;
				margin: 0 !important;
				border: 2px solid #EA3796 !important;
			}
		}
    }
	.disable_new{
		opacity: .6;
		cursor: no-drop !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/setting/manualStocktakesCOGs.vue